import apiClient from './client';

export interface StageMovement {
  id: number;
  lead_id: number;
  from_stage: string;
  to_stage: string;
  moved_by?: number;
  moved_at: string;
  reason?: string;
  metadata?: any;
}

export const stageMovementsApi = {
  getAll: async (leadId?: number): Promise<StageMovement[]> => {
    const params: any = {};
    if (leadId) params.leadId = leadId.toString();
    const response = await apiClient.get<{ success: boolean; data: StageMovement[] }>('/stage-movements', { params });
    return response.data.data;
  },
  getByLeadId: async (leadId: number): Promise<StageMovement[]> => {
    const response = await apiClient.get<{ success: boolean; data: StageMovement[] }>(`/stage-movements/lead/${leadId}`);
    return response.data.data;
  },
  getById: async (id: number): Promise<StageMovement> => {
    const response = await apiClient.get<{ success: boolean; data: StageMovement }>(`/stage-movements/${id}`);
    return response.data.data;
  },
};
